module.exports = __webpack_public_path__ + "static/atlaskit-multi-select-14057cfccf9088f9a74c806f29b40eca.png";